import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};
  color: ${({ theme }) => theme.colors.neutral.white};
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h2 {
    font-size: 20px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  p,
  span {
    font-size: 14px;
    line-height: 1.6;
    color: ${({ theme }) => theme.colors.neutral.cinza200};
    white-space: pre-line;
  }
`;

// Lista com marcador dos dados objetivos, espelhando a coluna direita do slide
// (Local, Expectativa de público, Compromissos, Saldo a captar).
export const DataList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding-left: 18px;

  li {
    font-size: 14px;
    line-height: 1.6;
    color: ${({ theme }) => theme.colors.neutral.cinza200};
  }

  strong {
    color: ${({ theme }) => theme.colors.neutral.white};
  }
`;

// Book de captação — a única ação que o patrocinador tem neste modo. O botão em
// si é o `Button` global (mesma aparência do card), então aqui só o alinhamento.
//
// ⚠️ O `Button` global é `display: flex` com o TEXTO SOLTO dentro, e texto solto
// em container flex vira um item ANÔNIMO — que não recebe `min-width: auto` e
// portanto encolhe abaixo do próprio conteúdo quando o contexto é estreito.
// Foi o que aconteceu aqui: o botão ficou com 45px de largura para 64px de
// conteúdo, e "PDF comercial" quebrou em duas linhas vazando a borda.
// `nowrap` + `flex: 0 0 auto` tiram o botão da negociação de largura; o wrapper
// não usa `align-self: flex-start` justamente para não entrar em shrink-to-fit.
export const BookAction = styled.div`
  display: flex;

  > button {
    flex: 0 0 auto;
    white-space: nowrap;
  }
`;

export const Empty = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.cinza200};
`;
